var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "../ts/modules/services/requests/termAccessDocumentRequest", "./modules/services/toastNotification", "./modules/services/validator", "./modules/utils/selfServiceRouteHelper"], function (require, exports, termAccessDocumentRequest_1, toastNotification_1, validator_1, selfServiceRouteHelper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    termAccessDocumentRequest_1 = __importDefault(termAccessDocumentRequest_1);
    validator_1 = __importStar(validator_1);
    selfServiceRouteHelper_1 = __importDefault(selfServiceRouteHelper_1);
    var possibleLabelValues = ["CPF", "RG", "Doc. estrangeiro"];
    var attemptsSpan = document.querySelector("#attempts");
    var nextAttemptTimerSpan = document.querySelector("#nextAttempt");
    var nextAttemptDiv = document.querySelector("#divNextAttempt");
    var documentTypeField = document.querySelector("#DocumentType");
    var documentNumberLabel = document.querySelector("#LabelRequirerDocument");
    var documentNumberField = document.querySelector("#DocumentNumber");
    var cardholderNameField = document.querySelector("#CardHolderName");
    var btnValidate = document.querySelector("#btn-validar");
    var form = document.querySelector("#AccessDocumentForm");
    var justValidateErrorLabelClass = 'just-validate-error-label';
    var justValidateErrorInputClass = 'is-invalid';
    var setIntervalId = 0;
    var termAccessDocumentRequest;
    var blockedFieldClassList = ['cursor-not-allowed', 'bg-gray-300'];
    var releasedFieldClassList = ['bg-gray-100', 'hover:border-gray-500'];
    var errorMessages = {
        verifyAccessDocumentRequest: "Ocorreu um erro ao verificar o documento de acesso."
    };
    var toastTimeout = 5000;
    var onLoad = function () {
        init();
        bindEvents();
        setTimer();
        if (documentTypeField && documentNumberLabel) {
            documentTypeField.options[0].selected = true;
            documentTypeField.addEventListener("change", HandleChangeDocumentType);
            documentNumberLabel.innerText = possibleLabelValues[0];
        }
        if (documentNumberField) {
            documentNumberField.addEventListener("input", NumbersOnly);
        }
        documentNumberField.addEventListener('keyup', function () { return clearValidationErros(); });
        cardholderNameField.addEventListener('keyup', function () { return clearValidationErros(); });
    };
    var init = function () {
        termAccessDocumentRequest = new termAccessDocumentRequest_1.default();
    };
    var bindEvents = function () {
        btnValidate === null || btnValidate === void 0 ? void 0 : btnValidate.addEventListener('click', validate);
    };
    var setTimer = function () {
        if (nextAttemptDiv && Helpers.isVisible(nextAttemptDiv))
            setIntervalId = window.setInterval(timer, 1000);
    };
    var verifyAccessDocument = function () { return __awaiter(void 0, void 0, void 0, function () {
        var documentType, documentNumber, cardholderName, payload_1, response, error_1;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    documentType = (_a = documentTypeField === null || documentTypeField === void 0 ? void 0 : documentTypeField.value) !== null && _a !== void 0 ? _a : "";
                    documentNumber = (_b = documentNumberField === null || documentNumberField === void 0 ? void 0 : documentNumberField.value) !== null && _b !== void 0 ? _b : "";
                    cardholderName = (_c = cardholderNameField === null || cardholderNameField === void 0 ? void 0 : cardholderNameField.value) !== null && _c !== void 0 ? _c : "";
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 4]);
                    blockFields();
                    payload_1 = {
                        accessToken: getAccessTokenFromUrl(),
                        accessDocument: {
                            documentType: Number(documentType),
                            documentNumber: documentNumber,
                            cardholderName: cardholderName
                        }
                    };
                    return [4, termAccessDocumentRequest.verifyAccessDocument(payload_1)];
                case 2:
                    response = _g.sent();
                    if (!response.success) {
                        toastNotification_1.ToastNotification.Error((_d = response === null || response === void 0 ? void 0 : response.message) !== null && _d !== void 0 ? _d : errorMessages.verifyAccessDocumentRequest);
                        return [2];
                    }
                    if ((_e = response.obj) === null || _e === void 0 ? void 0 : _e.match) {
                        toastNotification_1.ToastNotification.Success("Acesso liberado.", toastTimeout);
                        setTimeout(function () { return showTerm(payload_1); }, 1500);
                    }
                    else {
                        reset();
                        nextAttempt(response.obj);
                    }
                    return [3, 4];
                case 3:
                    error_1 = _g.sent();
                    toastNotification_1.ToastNotification.Error((_f = error_1 === null || error_1 === void 0 ? void 0 : error_1.message) !== null && _f !== void 0 ? _f : errorMessages.verifyAccessDocumentRequest);
                    reset();
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var showTerm = function (accessDocumentRequest) { return __awaiter(void 0, void 0, void 0, function () {
        var baseUrl, response, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    baseUrl = document.getElementsByTagName('base')[0].href;
                    return [4, termAccessDocumentRequest.sendAccessDocument(accessDocumentRequest)];
                case 1:
                    response = _a.sent();
                    toastNotification_1.ToastNotification.Success(response.obj);
                    url = selfServiceRouteHelper_1.default.isSelfService() ? baseUrl + "autosservico/" : baseUrl;
                    location.href = url + "cliente/Termo/f332d8d8-77e5-4246-bb6e-b3c675f1b68f";
                    return [2];
            }
        });
    }); };
    var nextAttempt = function (data) {
        if (!attemptsSpan || !documentTypeField || !documentNumberField || !documentTypeField || !nextAttemptTimerSpan || !nextAttemptDiv)
            return;
        documentNumberField.focus();
        attemptsSpan.textContent = String((data === null || data === void 0 ? void 0 : data.attempts));
        if ((data === null || data === void 0 ? void 0 : data.attempts) === 0) {
            toastNotification_1.ToastNotification.Error("O n\u00FAmero de tentativas com dados incorretos foi excedido\n                                 Favor aguardar o tempo para pr\u00F3xima tentativa.", toastTimeout);
            blockFields();
            Helpers.markRed(attemptsSpan);
            if (data === null || data === void 0 ? void 0 : data.nextAttempt) {
                Helpers.showElement(nextAttemptDiv);
                nextAttemptTimerSpan.textContent = data.nextAttempt.split('.')[0];
                setTimer();
            }
            return;
        }
        var wrongInfoMessage = 'Não foi possível validar as informações fornecidas. Por favor preencha novamente e tente outra vez';
        if (selfServiceRouteHelper_1.default.isSelfService())
            toastNotification_1.ToastNotification.Error(wrongInfoMessage, toastTimeout);
        else
            toastNotification_1.ToastNotification.Alert(wrongInfoMessage, toastTimeout);
    };
    var getAccessTokenFromUrl = function () { var _a; return (_a = window.location.href.split('/').pop()) !== null && _a !== void 0 ? _a : ""; };
    var reset = function () {
        if (!attemptsSpan || !documentTypeField || !documentNumberField || !documentTypeField || !nextAttemptTimerSpan || !nextAttemptDiv)
            return;
        clearFields();
        releaseFields();
    };
    var timer = function () {
        var _a, _b;
        if (!nextAttemptTimerSpan)
            return;
        var _c = (_b = (_a = nextAttemptTimerSpan.textContent) === null || _a === void 0 ? void 0 : _a.split(':')) !== null && _b !== void 0 ? _b : [], h = _c[0], m = _c[1], s = _c[2];
        var hour = Number(h);
        var minute = Number(m);
        var second = Number(s);
        if (second > 0) {
            second--;
        }
        else {
            second = 59;
            minute--;
            if (minute == 0 && hour > 0) {
                hour--;
            }
        }
        if (second === 0 && minute === 0 && hour === 0) {
            clearInterval(setIntervalId);
            reload();
        }
        formatTimer(hour, minute, second);
    };
    var formatTimer = function (hour, minute, second) {
        var strHour = hour >= 10 ? String(hour) : "0" + String(hour);
        var strMinute = minute >= 10 ? String(minute) : "0" + String(minute);
        var strSecond = second >= 10 ? String(second) : "0" + String(second);
        if (nextAttemptTimerSpan)
            nextAttemptTimerSpan.textContent = strHour + ":" + strMinute + ":" + strSecond;
    };
    var reload = function () {
        var delay = 1000;
        setTimeout(function () { return location.reload(); }, delay);
    };
    var Helpers = {
        isVisible: function (element) { return !element.classList.contains('hidden'); },
        clearField: function (element) { return element.value = ''; },
        clearSelect: function (element) { return element.selectedIndex = 0; },
        blockField: function (element) {
            var _a, _b;
            (_a = element.classList).add.apply(_a, blockedFieldClassList);
            (_b = element.classList).remove.apply(_b, releasedFieldClassList);
            element.setAttribute('disabled', 'disabled');
        },
        releaseField: function (element) {
            var _a, _b;
            (_a = element.classList).add.apply(_a, releasedFieldClassList);
            (_b = element.classList).remove.apply(_b, blockedFieldClassList);
            element.removeAttribute('disabled');
        },
        showElement: function (element) {
            element.classList.remove('hidden');
        },
        markRed: function (element) {
            element.classList.remove('text-green-500');
            element.classList.add('text-red-500');
        },
    };
    function HandleChangeDocumentType() {
        if (documentNumberLabel && documentTypeField) {
            var value = Number(documentTypeField.value);
            documentNumberLabel.innerText = possibleLabelValues[value];
        }
    }
    function NumbersOnly() {
        if (documentNumberField) {
            var value = Number(documentNumberField.value);
            if (value !== 0)
                return;
            this.value = this.value.replace(/[^0-9]/g, '');
        }
    }
    var clearFields = function () {
        Helpers.clearSelect(documentTypeField);
        Helpers.clearField(documentNumberField);
        Helpers.clearField(cardholderNameField);
        HandleChangeDocumentType();
    };
    var blockFields = function () {
        Helpers.blockField(documentTypeField);
        Helpers.blockField(documentNumberField);
        Helpers.blockField(cardholderNameField);
    };
    var releaseFields = function () {
        Helpers.releaseField(documentTypeField);
        Helpers.releaseField(documentNumberField);
        Helpers.releaseField(cardholderNameField);
    };
    var validation = {
        getBaseValidator: function (form) {
            return validator_1.default(form)
                .addField('#DocumentNumber', [
                {
                    rule: validator_1.Rules.Required,
                    errorMessage: 'Informe o documento do solicitante.'
                },
            ])
                .addField('#CardHolderName', [
                {
                    rule: validator_1.Rules.Required,
                    errorMessage: 'Informe o nome do solicitante.'
                },
            ]);
        }
    };
    var validate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var validator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    validator = validation.getBaseValidator(form);
                    clearValidationErros();
                    return [4, validator.validate(true)
                            .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!validator.isValid) return [3, 2];
                                        return [4, verifyAccessDocument()];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2];
                                }
                            });
                        }); })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var clearValidationErros = function () {
        var divs = document.querySelectorAll("." + justValidateErrorLabelClass);
        divs.forEach(function (item) { return item.remove(); });
        var inputs = document.querySelectorAll("." + justValidateErrorInputClass);
        inputs.forEach(function (item) { return item.classList.remove(justValidateErrorInputClass); });
    };
    window.addEventListener('load', onLoad);
});
